// Open Photoswipe/Lightbox bij klik op de productafbeelding (Impact)
(() => {
  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  onReady(() => {
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    // Event delegation: werkt met sliders en lazy-loaded media
    gallery.addEventListener('click', (e) => {
      // Klik moet op een IMG binnen .product-gallery__media zijn
      const img = e.target.closest('.product-gallery__media img');
      if (!img || !gallery.contains(img)) return;

      // Niet dubbel vuren als je op de zoom-knop zelf klikt
      if (e.target.closest('button[is="product-zoom-button"]')) return;

      const media = img.closest('.product-gallery__media');
      if (!media) return;

      // Alleen voor images (niet voor video/slides met external_video)
      const type = media.getAttribute('data-media-type');
      if (type && type !== 'image') return;

      // 1) Prefer: de zoom-knop in dezelfde slide (desktop)
      let opener = media.querySelector('button[is="product-zoom-button"]');

      // 2) Fallback: de globale/mobile zoom-knop
      if (!opener) {
        opener =
          gallery.querySelector('.product-gallery__zoom button[is="product-zoom-button"]') ||
          document.querySelector('.product-gallery__zoom button[is="product-zoom-button"]');
      }

      if (opener) {
        e.preventDefault();
        opener.click(); // opent de ingebouwde lightbox op de juiste slide
      }
    });

    // Mooie cursorhint
    const style = document.createElement('style');
    style.textContent = `product-gallery .product-gallery__media img { cursor: zoom-in; }`;
    document.head.appendChild(style);
  });
})();
